var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Device, useShowToast } from "@madmedical/ui";
import { usePatientId } from "@madmedical/user";
import { useGetPatientProtocolsQuery } from "@madmedical/threshold";
import { useState } from "react";
import { useTranslation } from "@madmedical/i18n";
import useBleContext from "../ble/useBleContext";
import useBlePersistence from "../ble/useBlePersistence";
const BleDevice = ({ device, canAddDevice, showAppDownload, onDismissAppDownload, }) => {
    var _a;
    const { patientId } = usePatientId();
    const [isLoading, setLoading] = useState(false);
    const { connect, disconnect } = useBleContext();
    const { addDevice, removeDevice } = useBlePersistence();
    const showToast = useShowToast();
    const { data: protocols } = useGetPatientProtocolsQuery({ patientId });
    const { t } = useTranslation();
    const handleConnectPress = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!connect) {
            // We probably are on web
            return;
        }
        setLoading(true);
        try {
            const connectResponse = yield connect(device.provider);
            if (connectResponse.status === "notFound") {
                showToast(t("deviceNotfound"), { variant: "error" });
                return;
            }
            yield addDevice(connectResponse.device);
            showToast(t("successfulConnection"), { variant: "success" });
        }
        catch (err) {
            console.log("ERROR", err, JSON.stringify(err));
            showToast(t("unsuccessfulConnection"), { variant: "error" });
        }
        finally {
            setLoading(false);
        }
    });
    const handleDisconnectPress = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield removeDevice(device.provider);
            disconnect === null || disconnect === void 0 ? void 0 : disconnect(device.provider);
            showToast(t("deviceDisconnected"), { variant: "success" });
        }
        catch (e) {
            console.error(e);
            showToast(t("deviceDisconnectedUnsuccessful"), {
                variant: "error",
            });
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsx(Device, { device: device, protocols: (_a = protocols === null || protocols === void 0 ? void 0 : protocols.filter(({ metricType }) => device.metricTypes.includes(metricType))) !== null && _a !== void 0 ? _a : [], onConnectPress: handleConnectPress, onDisconnectPress: handleDisconnectPress, canAddDevice: canAddDevice, isConnectLoading: isLoading, showAppDownload: showAppDownload, onDismissAppDownload: onDismissAppDownload }));
};
export default BleDevice;
